export default __webpack_public_path__ + "static/media/rocket_2.1607d656.svg";